<cor-dialog-box
  [(visible)]="visible"
  title="Save with comment"
  (onHide)="closePopup()">
  <cor-input-container label="Snapshot Name">
    <input
      test-id="edit-change-log-provide-a-snapshot-name"
      pInputText
      type="text"
      [fluid]="true"
      [(ngModel)]="versionName"
      placeholder="Provide a snapshot name" />
  </cor-input-container>

  <cor-input-container label="Comment">
    <cor-description
      test-id="edit-change-log-here-you-can-put-a-brief-description-on"
      [(ngModel)]="comment"
      placeholder="Here you can put a brief description on the changes done"
      [minHeight]="70" />
  </cor-input-container>

  <ng-template #footer>
    <div class="tw:flex tw:gap-2">
      <p-button
        test-id="edit-change-log-cancel"
        [buttonProps]="{ autofocus: false }"
        (click)="closePopup()"
        severity="secondary"
        label="Cancel" />
      <p-button
        test-id="edit-change-log-submit-changes"
        [buttonProps]="{ autofocus: false }"
        (click)="confirmAction()"
        label="Submit Changes" />
    </div>
  </ng-template>
</cor-dialog-box>
